import { useContext } from 'react';

import { Result } from '../../Interface/Response/Validator/Result';
import ResultContext from '../../Context/ResultContext';
import { Rule as AcceptanceFeatureRule } from '../../Interface/Response/Validator/Results/Review/Response/Rule';

interface ValidatorResultRules {
    acceptanceFeatureRules: AcceptanceFeatureRule[];
}

const useValidatorResult = (scopeName: string): ValidatorResultRules | null => {
    const result = useContext<Result | null>(ResultContext);

    if (!result) {
        return null;
    }

    const acceptanceFeatureRules = result.beoordeling.beoordelingResponse.regel.filter(
        rule => rule.scope === scopeName,
    );

    return { acceptanceFeatureRules };
};

export default useValidatorResult;
